export default class WindowEnv {
  static isChoicesEnabled() {
    return window.ENV.settings.choices_enabled;
  }

  static isWithinPodcastApp() {
    return window.ENV.settings.within_podcast_app;
  }
}
